export default __webpack_public_path__ + "static/media/master-card.1bbf4390.svg";